export const getTextContent = (htmlString: string | undefined) => {
  if (!htmlString) return;
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || '';
};
